// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Okv6","selected":"styles_selected__3dSMG"};